import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section id="guarantee" className="py-10 md:py-20 bg-brand-panel/85 backdrop-blur-sm border-y border-brand-border" data-id="element-104">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-brand-gold/10 border-2 border-brand-gold/30 mb-6 md:mb-8" data-id="element-106">
          <ShieldCheck className="w-8 h-8 md:w-10 md:h-10 text-brand-gold" data-id="element-107" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-serif font-bold text-white mb-4 md:mb-6" data-id="element-108">
          7 Días de Garantía Total
        </motion.h2>
        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-2xl text-brand-gold font-medium mb-6 md:mb-8" data-id="element-109">
          Si no te gusta, te devolvemos el 100%
        </motion.h3>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-base md:text-lg text-gray-400 leading-relaxed mb-6 md:mb-8" data-id="element-110">
          Abrís los tomos, probás las recetas del fin de semana. Si no es lo que
          esperabas: sin preguntas, sin formularios, sin drama. Te devolvemos
          todo en 24 horas. Así de simple.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="inline-block bg-brand-dark px-4 md:px-6 py-2 md:py-3 rounded-full border border-brand-border text-xs md:text-sm text-gray-500 font-semibold tracking-wider" data-id="element-111">
          TASA DE DEVOLUCIONES MENOR AL 1%
        </motion.div>
      </div>
    </section>;
}